document.addEventListener('DOMContentLoaded', function () {

  var overlay = document.getElementById('overlay');
  var cartDrawer = document.getElementById('cartDrawer');
  var bagBtn = document.getElementById('bagBtn');
  var cartClose = document.getElementById('cartClose');
  var menuToggle = document.getElementById('menuToggle');
  var mobileNav = document.getElementById('mobileNav');

  function openCart() {
    overlay.classList.add('open');
    cartDrawer.classList.add('open');
  }
  function closeDrawers() {
    overlay.classList.remove('open');
    cartDrawer.classList.remove('open');
    var reqDrawer = document.getElementById('requestDrawer');
    if (reqDrawer) reqDrawer.classList.remove('open');
  }

  if (bagBtn) bagBtn.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeDrawers);
  if (overlay) overlay.addEventListener('click', closeDrawers);
  if (menuToggle) menuToggle.addEventListener('click', function () {
    mobileNav.classList.toggle('open');
  });
  if (mobileNav) {
    mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { mobileNav.classList.remove('open'); });
    });
  }

  /* ---------- Cart rendering ---------- */
  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderCart(cart) {
    var bagCount = document.getElementById('bagCount');
    if (bagCount) bagCount.textContent = cart.item_count;

    var cartStrip = document.getElementById('cartStrip');
    var cartBody = document.getElementById('cartBody');
    var subtotalAmt = document.getElementById('subtotalAmt');
    var checkoutBtn = document.getElementById('requestOrderBtn');

    if (!cart.items.length) {
      if (cartStrip) cartStrip.innerHTML = '<span class="cart-strip-empty">Your cart is empty — add a part to get started.</span>';
      if (cartBody) cartBody.innerHTML = '<div class="drawer-empty">Nothing here yet.<br>Browse the collection to start building.</div>';
      if (checkoutBtn) checkoutBtn.setAttribute('disabled', 'disabled');
    } else {
      if (cartStrip) {
        var chainHtml = '<div class="cart-strip-line">';
        cart.items.forEach(function (item, idx) {
          if (idx > 0) chainHtml += '<span class="cart-strip-link"></span>';
          var img = item.image ? item.image.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_80x80$1$2') : '';
          chainHtml += '<span class="cart-thumb-mini">' + (img ? '<img src="' + img + '" alt="">' : '') + '</span>';
        });
        chainHtml += '</div>';
        cartStrip.innerHTML = chainHtml;
      }
      if (cartBody) {
        cartBody.innerHTML = cart.items.map(function (item) {
          var img = item.image ? item.image.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_160x160$1$2') : '';
          return '' +
            '<div class="cart-line" data-key="' + item.key + '">' +
              '<div class="thumb">' + (img ? '<img src="' + img + '" alt="">' : '') + '</div>' +
              '<div class="cart-line-info">' +
                '<h5>' + item.product_title + '</h5>' +
                '<div class="price">' + (window.ASK_FOR_PRICE_TEXT || 'Ask for price') + '</div>' +
                '<div class="qty-row">' +
                  '<button class="qty-btn" data-act="dec" data-key="' + item.key + '" data-qty="' + item.quantity + '">−</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button class="qty-btn" data-act="inc" data-key="' + item.key + '" data-qty="' + item.quantity + '">+</button>' +
                  '<button class="remove-link" data-act="rm" data-key="' + item.key + '">Remove</button>' +
                '</div>' +
              '</div>' +
            '</div>';
        }).join('');
      }
      if (checkoutBtn) checkoutBtn.removeAttribute('disabled');
    }
    if (subtotalAmt) subtotalAmt.textContent = window.ASK_FOR_PRICE_TEXT || 'Ask for price';
    bindCartLineEvents();
  }

  function fetchCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  function changeQuantity(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function bindCartLineEvents() {
    document.querySelectorAll('[data-act="inc"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeQuantity(btn.dataset.key, parseInt(btn.dataset.qty) + 1);
      });
    });
    document.querySelectorAll('[data-act="dec"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeQuantity(btn.dataset.key, parseInt(btn.dataset.qty) - 1);
      });
    });
    document.querySelectorAll('[data-act="rm"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeQuantity(btn.dataset.key, 0);
      });
    });
  }

  function addToCart(variantId, quantity, btn) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(function (r) { return r.json(); }).then(function () {
      if (btn) {
        var original = btn.textContent;
        btn.textContent = 'Added ✓';
        btn.classList.add('added');
        setTimeout(function () { btn.textContent = original; btn.classList.remove('added'); }, 1200);
      }
      fetchCart();
      openCart();
    });
  }

  document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      addToCart(btn.dataset.variantId, 1, btn);
    });
  });

  /* Product page quantity stepper */
  document.querySelectorAll('[data-qty-decrease]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.getElementById(btn.dataset.qtyDecrease);
      input.value = Math.max(1, parseInt(input.value || '1') - 1);
    });
  });
  document.querySelectorAll('[data-qty-increase]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.getElementById(btn.dataset.qtyIncrease);
      input.value = parseInt(input.value || '1') + 1;
    });
  });
  var qtyInputEl = document.getElementById('qtyInput');

  /* Product page gallery thumbs */
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.getElementById('mainProductImage');
      if (main) main.src = thumb.dataset.fullSrc;
    });
  });

  /* ---------- Request Order flow ---------- */
  var requestDrawer = document.getElementById('requestDrawer');
  var requestOrderBtn = document.getElementById('requestOrderBtn');
  var requestClose = document.getElementById('requestClose');
  var requestBody = document.getElementById('requestBody');
  var orderStep = 'location';
  var orderData = { name: '', phone: '', location: '', city: '' };
  var T2 = window.ORDER_UI_TEXT || {};

  function setRequestStepIndicator(step) {
    if (!requestDrawer) return;
    requestDrawer.querySelectorAll('.step').forEach(function (s) {
      s.classList.remove('active', 'done');
      var order = ['location', 'contact'];
      if (s.dataset.step === step) s.classList.add('active');
      else if (order.indexOf(s.dataset.step) < order.indexOf(step)) s.classList.add('done');
    });
  }

  function buildCartSummaryText(cart) {
    if (!cart || !cart.items || !cart.items.length) return '';
    return cart.items.map(function (item) {
      return '- ' + item.product_title + ' (x' + item.quantity + ')';
    }).join('\\n');
  }

  function renderRequestStep() {
    if (!requestBody) return;
    setRequestStepIndicator(orderStep);

    if (orderStep === 'location') {
      requestBody.innerHTML =
        '<div class="field full"><label>' + (T2.name || 'Full name') + '</label><input id="ro_name" type="text" value="' + orderData.name + '"></div>' +
        '<div class="field full"><label>' + (T2.phone || 'Phone number') + '</label><input id="ro_phone" type="tel" value="' + orderData.phone + '"></div>' +
        '<div class="field full"><label>' + (T2.location || 'Location / Address') + '</label><input id="ro_location" type="text" value="' + orderData.location + '"></div>' +
        '<div class="field full"><label>' + (T2.city || 'City') + '</label><input id="ro_city" type="text" value="' + orderData.city + '"></div>' +
        '<button class="btn btn-accent btn-full" id="ro_continue" style="margin-top:6px;">' + (T2.continueBtn || 'Continue') + '</button>';

      document.getElementById('ro_continue').addEventListener('click', function () {
        orderData.name = document.getElementById('ro_name').value;
        orderData.phone = document.getElementById('ro_phone').value;
        orderData.location = document.getElementById('ro_location').value;
        orderData.city = document.getElementById('ro_city').value;
        orderStep = 'contact';
        renderRequestStep();
      });
    }

    else if (orderStep === 'contact') {
      var settings = window.ORDER_SETTINGS || {};
      var phoneDisplay = window.CONTACT_PHONE_DISPLAY || settings.whatsapp || '';

      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var summary = buildCartSummaryText(cart);
        var waMessage = (T2.waIntro || "Hello, I'd like to order the following parts:") + '\\n' + summary +
          '\\n\\n' + (T2.waName || 'Name') + ': ' + orderData.name +
          '\\n' + (T2.waPhone || 'Phone') + ': ' + orderData.phone +
          '\\n' + (T2.waLocation || 'Location') + ': ' + orderData.location + ', ' + orderData.city;
        var waLink = 'https://wa.me/' + (settings.whatsapp || '') + '?text=' + encodeURIComponent(waMessage);

        requestBody.innerHTML =
          '<a class="back-link" id="ro_back">' + (T2.back || '← Back') + '</a>' +
          '<div class="demo-note"><strong>' + (T2.step1 || 'Step 1') + '</strong> ' + (T2.callInstructions || 'Call or message us on WhatsApp to settle a price for your order:') + '</div>' +
          '<p style="font-size:20px; font-weight:700; margin:4px 0 18px;"><a href="tel:' + (phoneDisplay || '').replace(/\\s/g, '') + '" style="color:var(--accent);">' + phoneDisplay + '</a></p>' +
          '<a href="' + waLink + '" target="_blank" rel="noopener" class="btn btn-accent btn-full" style="margin-bottom:24px;">' + (T2.waButton || 'Send Order via WhatsApp') + '</a>' +
          '<div class="demo-note"><strong>' + (T2.step2 || 'Step 2') + '</strong> ' + (T2.wishInstructions || 'Once a price is agreed, send payment via Wish Money to:') + '</div>' +
          '<div class="review-line"><span>' + (T2.wishNameLabel || 'Account name') + '</span><span>' + (settings.wishName || '') + '</span></div>' +
          '<div class="review-line"><span>' + (T2.wishNumberLabel || 'Account number') + '</span><span>' + (settings.wishNumber || '') + '</span></div>' +
          (settings.wishNote ? '<p style="color:var(--steel); font-size:13px; margin-top:14px;">' + settings.wishNote + '</p>' : '') +
          '<p class="drawer-note" style="margin-top:20px;">' + (T2.finalNote || 'We will confirm your order and arrange shipping once payment is received.') + '</p>';

        document.getElementById('ro_back').addEventListener('click', function () {
          orderStep = 'location';
          renderRequestStep();
        });
      });
    }
  }

  if (requestOrderBtn) {
    requestOrderBtn.addEventListener('click', function () {
      orderStep = 'location';
      renderRequestStep();
      cartDrawer.classList.remove('open');
      requestDrawer.classList.add('open');
      overlay.classList.add('open');
    });
  }
  if (requestClose) {
    requestClose.addEventListener('click', function () {
      requestDrawer.classList.remove('open');
      overlay.classList.remove('open');
    });
  }

  /* Initial cart render on load so JS-driven markup matches server state */
  fetchCart();
});
